export const SET_HOME = 'SET_HOME';
export const LOADING_HOME = 'LOADING_HOME';